import { render, staticRenderFns } from "./BiologicalCapital.vue?vue&type=template&id=7c32165c&scoped=true&"
import script from "./BiologicalCapital.vue?vue&type=script&lang=js&"
export * from "./BiologicalCapital.vue?vue&type=script&lang=js&"
import style0 from "./BiologicalCapital.vue?vue&type=style&index=0&id=7c32165c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c32165c",
  null
  
)

export default component.exports